import { Link, useLocation } from "react-router-dom";
import "./components.css";
import { useEffect, useState } from "react";
import permissionConfig from "../../Config/permissions";
import { MdOutlinePayment } from "react-icons/md";
import cmeazlogo from "../../assets/images/cmeaz_logo.png"

const Sidebar = () => {
  const location = useLocation(); // Get the current pathname
  const [menuItems, setMenuItems] = useState([
    {
      name: "Dashboard",
      icon: require("../../assets/images/home.png"),
      path: "/",
    },
    {
      name: "Lifestyle/Activity",
      icon: require("../../assets/images/downloads3.jpeg"),
      path: "/lifestyle",
    },
    {
      name: "Location",
      icon: require("../../assets/images/location2.jpeg"),
      path: "/location",
    },
    {
      name: "Language",
      icon: require("../../assets/images/language.jpg"),
      path: "/language",
    },
    {
      name: "Registered Users",
      icon: require("../../assets/images/Registeredusers.webp"),
      path: "/registeredusers",
    },
    {
      name: "Livestreams",
      icon: require("../../assets/images/live.png"),
      path: "/livestream",
    },
    {
      name: "All Events",
      icon: require("../../assets/images/courses.png"),
      path: "/allevent",
    },
    {
      name: "Add New Event",
      icon: require("../../assets/images/add.png"),
      path: "/addnewevent",
    },

    {
      name: "Settings",
      icon: require("../../assets/images/settings.png"),
      path: "/settings",
      subMenu: [
        {
          name: "Payment Gateway",
          icon: require("../../assets/images/batch.webp"),
          path: "/settings/payment-gateway",
        },
      ],
    },
    {
      name: "Participants",
      icon: require("../../assets/images/batch.webp"),
      path: "/participants",
    },
    {
      name: "Sponsors",
      icon: require("../../assets/images/batch.webp"),
      path: "/sponsors",
    },
     {
      name: "Organizers",
      icon: require("../../assets/images/batch.webp"),
      path: "/organizers",
    },
      {
      name: "EventTypes",
      icon: require("../../assets/images/batch.webp"),
      path: "/event-types",
    },
    {
      name: "Trainer",
      icon: require("../../assets/images/trainer.png"),
      path: "/trainer",
    },
    {
      name: "Category",
      icon: require("../../assets/images/categories.png"),
      path: "/category",
    },
    {
      name: "Orders",
      icon: require("../../assets/images/cart.png"),
      path: "/orders",
    },
    {
      name: "Speakers",
      icon: require("../../assets/images/trainer.png"),
      path: "/speakers",
    },
  ]);
  const [activeBatch, setActiveBatch] = useState(false);

  // Function to filter and update menu items
  const updateMenuItems = () => {
    const role = JSON.parse(localStorage.getItem("user_data")).role;
    const config = permissionConfig.find((item) => item.role === role);

    if (config) {
      const updatedMenu = menuItems
        .filter((item) => config.show.includes(item.name))
        .sort(
          (a, b) => config.show.indexOf(a.name) - config.show.indexOf(b.name)
        )
        .map((item) => ({
          ...item,
          active:
            // Check if path is root and location is root, else check for other paths
            item.path === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(item.path),
        }));

      setMenuItems(updatedMenu); // Update the state
    }
  };

  useEffect(() => {
    updateMenuItems(); // Update menu items on mount and when pathname changes
    const isPaymentPath =
      location.pathname === "/settings/payment-gateway" ||
      location.pathname === "/settings";
    // location.pathname === "/batch";
    setActiveBatch(isPaymentPath);
  }, [location.pathname]); // Dependency array includes location.pathname
  const handleBatchDropdown = () => {
    setActiveBatch(!activeBatch);
  };
  return (
    <div className="sidebar">
      <div className="logo-container">
        <img
          src={cmeazlogo}
          alt="logo"
          className="logo"
        />
      </div>
      <ul className="menu">
        {menuItems.map((item, index) => (
          <li key={index}>
            <Link
              to={item.path}
              className={`menu-item ${item.active ? "active" : ""}`}
              onClick={item.subMenu ? handleBatchDropdown : null}
            >
              <div className="icon-container">
                <img src={item.icon} alt={item.name} />
              </div>
              {item.name}
            </Link>
            {item.subMenu && activeBatch && (
              <ul className="submenu">
                {item.subMenu.map((subItem, subIndex) => (
                  <li key={subIndex}>
                    <Link
                      to={subItem.path}
                      className={`menu-item ${
                        location.pathname.startsWith(subItem.path)
                          ? "active"
                          : ""
                      }`}
                    >
                      <div className="icon-container">
                        <img src={subItem.icon} alt={subItem.name} />
                      </div>
                      {subItem.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
